/* eslint-disable  react/display-name*/
import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
  Grid,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Receive from "@mui/icons-material/CallReceived";
import RefreshIcon from "@mui/icons-material/Refresh";
import db from "../../db/db";

import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";
import Payin from "../Cashflow/payin/PayinCrud";
import CustomerTrasactionList from "../customer/customertransaction/CustomertransactionList";
import CustomerCrud from "./CustomerCrud.jsx";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function CustomerList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 345) / 25)
  );

  useEffect(() => {
    loadData();
  }, []);

  function addCustomer() {
    biRef.child.showCustomerCrudWindow(null);
  }

  function onEditClicked(row) {
    biRef.child.showCustomerCrudWindow(row.tableData[row.rowIndex]._id);
  }

  function onHistoryClicked(row) {
    console.log(
      "fetch customer Transactions: " + row.tableData[row.rowIndex].id
    );
    biRef.transactions.showTransactionList(
      row.tableData[row.rowIndex].id,
      row.tableData[row.rowIndex].name
    );
  }

  async function loadData() {
    let sort = '[{id:"custId",sortOrder:"ASC"}]';
    let search = "[]";
    loadByRest(0, rowLimitPerPage, sort, search);
    //loaadByDB();
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    try {
      setIsLoading(true);
      const result = await API.get(
        "/api/v1/customers?range=" +
          encodeURIComponent(
            "[" +
              curPage * pageSize +
              "," +
              ((curPage + 1) * pageSize - 1) +
              "]"
          ) +
          "&filter=" +
          encodeURIComponent(filter) +
          "&sort=" +
          encodeURIComponent(sort)
      );
      var arr = result.data.contentRange.split("/");
      const opt = { ...option };
      opt.count = parseInt(arr[2]);
      setOption(opt);
      setData(result.data.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.error("ERROR", err);
      props.showMessage(
        "error",
        translate("Not able to retrive sale history from server")
      );
    }
  }

  async function onTableChange(tableState) {
    let sort = '[{id:"custId",sortOrder:"ASC"}]';
    /*if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }*/

    let search = "[";
    if (tableState.searchText) {
      search +=
        '{id:"name",value:"",regExp:".*(?i)' +
        tableState.searchText +
        '.*",matchType:"BROAD_MATCH",operatorType:"",fieldValueType:"string","conditionType":"or"}';
      search +=
        ',{id:"micrCode",value:"",regExp:".*' +
        tableState.searchText +
        '.*",matchType:"BROAD_MATCH",operatorType:"",fieldValueType:"string","conditionType":"or"}';
      search +=
        ',{id:"mobile",value:"",regExp:".*' +
        tableState.searchText +
        '.*",matchType:"BROAD_MATCH",operatorType:"",fieldValueType:"string","conditionType":"or"}';
    }
    search += "]";
    loadByRest(tableState.page, rowLimitPerPage, sort, search);
  }

  const options = {
    download: false,
    searchPlaceholder: "Search by fields",
    serverSide: true,
    searchable: true,
    viewColumns: false,
    filter: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: getWindowDimensions().height - 225,
    rowsPerPage: Math.round((getWindowDimensions().height - 345) / 25),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 345) / 25),
      10,
      15,
      50,
      100,
    ],
    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want
      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        case "filterChange":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={translate("Refresh Data")}>
            <IconButton
              size="small"
              color="primary"
              onClick={customerListRefresh}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title={translate("Add New Customer")}>
            <IconButton size="small" color="secondary" onClick={addCustomer}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  const [option, setOption] = useState(options);

  const columns = [
    {
      name: "custId",
      label: translate("Id"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "name",
      label: translate("Name"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "micrCode",
      label: "Micr",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "mobile",
      label: translate("Phone"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({ align: "right" }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <Button
              onClick={() => onEditClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                marginRight: 3,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "center",
              }}
            >
              {props.context.privileges.customer_edit
                ? translate("Edit")
                : translate("View")}
            </Button>

            {/*<Button
              onClick={() => onHistoryClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "center",
              }}
            >
              Ledger
            </Button>*/}
            <CustomerTrasactionList biRef={biRef} />
          </div>
        ),
      },
    },
  ];

  function customerListRefresh() {
    loadData();
  }

  var biRef = {};

  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={
              <Typography variant="h6">
                {translate("Customer List")}
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{
                      marginLeft: 15,
                      position: "relative",
                      top: 4,
                    }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
      <CustomerCrud
        biRef={biRef}
        showMessage={props.showMessage}
        onRefresh={customerListRefresh}
        context={props.context}
      ></CustomerCrud>
    </Grid>
  );
}
